import React, { useState, useEffect } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Contact } from "./components/contact";
import Newsletter from "./components/newsletter";
import Faq from "./components/faq";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";

// Use the scroll instance to scroll to the top of the page
export const scroll = new SmoothScroll('a[href*="#"]', {
    speed: 1000,
    speedAsDuration: true,
});

const App = () => {
    const [landingPageData, setLandingPageData] = useState({});
    // State to manage the visibility of the scroll-to-top button
    const [showScroll, setShowScroll] = useState(false);

    // Load data on component mount
    useEffect(() => {
        setLandingPageData(JsonData);
    }, []);

    // Effect to handle scroll event and update button visibility
    useEffect(() => {
        const checkScrollTop = () => {
            // Show the button if the user has scrolled more than 400px down
            if (!showScroll && window.pageYOffset > 400) {
                setShowScroll(true);
            } else if (showScroll && window.pageYOffset <= 400) {
                setShowScroll(false);
            }
        };

        window.addEventListener("scroll", checkScrollTop);

        // Cleanup the event listener on component unmount
        return () => window.removeEventListener("scroll", checkScrollTop);
    }, [showScroll]); // Dependency on showScroll ensures the latest state is used

    // Function to scroll to the top of the document
    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div style={{ overflowX: 'hidden' }}>
            <Navigation />
            <Header data={landingPageData.Header} />
            <About data={landingPageData.About} />
            <Services data={landingPageData.Services} />
            <Gallery data={landingPageData.Gallery} />
            <Newsletter />
            <Faq contact={landingPageData.Contact} />
            <Contact data={landingPageData.Contact} />

            {/* Scroll-to-Top Button */}
            {showScroll && (
                <button
                    onClick={scrollTop}
                    className="scrollTop"
                    title="Go to top"
                >
                    {/* You can use an icon here, e.g., a simple up arrow */}
                    &#x2191; 
                </button>
            )}
        </div>
    );
};

export default App;
